<template>
    <b-form-radio v-model="value" v-bind="{ ...schema, ...schema.attributes }">{{ schema.text }}</b-form-radio>
</template>

<script>
    import { abstractField } from "vue-form-generator";
    export default {
        mixins: [abstractField]
    };
</script>

<style></style>
